import { Injectable } from '@angular/core';
import firebase from 'firebase';

@Injectable()
export class AuthProvider {

  firebaseRoot: any;
  currentUser: any;

  constructor() {
    console.log('Hello AuthProvider Provider');
  }
  init() {
    const config = {
      apiKey: "AIzaSyBGdEZu7rl5YOF3L2vfgZItrHWcQzRmZoA",
      authDomain: "qlogbook.firebaseapp.com",
      databaseURL: "https://qlogbook.firebaseio.com",
      projectId: "qlogbook",
      storageBucket: "qlogbook.appspot.com",
      messagingSenderId: "101407256092"
    }
    try {

      firebase.initializeApp(config);
      this.firebaseRoot = firebase.database().ref();
      console.log('firebaseRoot: ' + this.firebaseRoot.toString());
      const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
        if (!user) {
          unsubscribe();
        } else {
          this.currentUser = user;
          //console.log('user: ' + JSON.stringify(this.currentUser));
          unsubscribe();
        }
      });
    } catch (error) {
      console.log('firebase init: ' + error);
    }
  }

  loginUser(email: string, password: string) {
    return firebase.auth().signInWithEmailAndPassword(email, password);
  }

  logoutUser() {
    //const userId: string = firebase.auth().currentUser.uid;
    //this.fbdb.logoutUser(userId);
    return firebase.auth().signOut();
  }

  signupUser(email: string, password: string) {
    
    return firebase.auth().createUserWithEmailAndPassword(email, password)
      
  }

  resetPassword(email: string) {
    return firebase.auth().sendPasswordResetEmail(email);
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts